import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { deleteSlip } from '../actions';
import { Slip } from '../reducer';
import { getSavedSlipWithReturns } from '../selectors';

export const SavedSlipDetails = ({ slip, onDeleteSlip }) => (
  <div className="saved-slip-details">
    {slip.legs.map(selection => (
      <div className="saved-slip-details__section" key={selection.selectionId}>
        <div className="saved-slip-details__line">
          <b>
            {selection.selectionName} @{' '}
            {selection.selectionPriceNum}/{selection.selectionPriceDen}
          </b>
        </div>
        <div className="saved-slip-details__line">{selection.marketName}</div>
        <div className="saved-slip-details__line">{selection.eventName}</div>
      </div>
    ))}
    <div className="saved-slip-details__section">
      <div className="saved-slip-details__line">
        <div>Stake:</div>
        <div>£{Number(slip.slipStake).toFixed(2)}</div>
      </div>
      <div className="saved-slip-details__note">
        Note: you can update your stake when placing your bet.
      </div>
    </div>
    <div className="saved-slip-details__section">
      <div className="saved-slip-details__line">
        <div>Returns:</div>
        <div><b>£{Number(slip.potentialReturns).toFixed(2)}</b></div>
      </div>
    </div>
    <div className="saved-slip-details__section">
      <div className="saved-slip-details__note">
        Odds may change in the period between slip generation and
        placing a bet in shop.
      </div>
      <div className="saved-slip-details__note">
        <b>Generated:</b> {slip.slipCreatedDateTime}<br />
        <b>Expires:</b> {slip.expiryDateTime}
      </div>
    </div>
    <Button
      className="button--wide button--danger saved-slip-details__button"
      onClick={onDeleteSlip}
    >
      Delete Slip
    </Button>
  </div>
);

SavedSlipDetails.propTypes = {
  slip: PropTypes.instanceOf(Slip).isRequired,
  onDeleteSlip: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  slip: getSavedSlipWithReturns(state, props)
});

const mapDispatchToProps = (dispatch, { id }) => ({
  onDeleteSlip: () => dispatch(deleteSlip(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedSlipDetails);
